module.exports = __webpack_public_path__ + "img/favicon-32x32.983e83bd.png";